import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "88c5e278-f955-49c0-abf4-661f56e80769",
    content: "Sound 1",
    options: {
      clickAudioUrl: `${config.ASSETS_URL}/05/05/task/task-01-sound-01.wav`,
    },
  },
  {
    id: "949d8199-0ef2-47db-ac12-db7f86438179",
    content: "Sound 2",
    options: {
      clickAudioUrl: `${config.ASSETS_URL}/05/05/task/task-01-sound-02.wav`,
    },
  },
  {
    id: "bf24f8ff-f8a6-4f8f-a8ac-278af682105f",
    content: "Sound 3",
    options: {
      clickAudioUrl: `${config.ASSETS_URL}/05/05/task/task-01-sound-03.wav`,
    },
  },
  {
    id: "a5229193-0323-4b85-811c-ab64df0a08bb",
    content: "Sound 4",
    options: {
      clickAudioUrl: `${config.ASSETS_URL}/05/05/task/task-01-sound-04.wav`,
    },
  },
  {
    id: "5272da7d-b336-4b7d-941a-298ceebc2bc1",
    content: "Sound 5",
    options: {
      clickAudioUrl: `${config.ASSETS_URL}/05/05/task/task-01-sound-05.wav`,
    },
  },
];

const groups = [
  {
    id: "ba0f3774-4617-4de7-8529-bab966f33ce6",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/05/task/task-1-group-1.svg`,
    },
  },
  {
    id: "73eda6e7-87ed-49ca-accd-61143de3073f",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/05/task/task-1-group-2.svg`,
    },
  },
  {
    id: "654c1d80-74d8-49c2-8408-46f781358e7d",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/05/task/task-1-group-3.svg`,
    },
  },
  {
    id: "b4af847b-5ce3-443d-a30d-52a73b1bf253",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/05/task/task-1-group-4.svg`,
    },
  },
  {
    id: "a0a7ac46-b9bc-4f33-a684-f55fb862138c",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/05/task/task-1-group-5.svg`,
    },
  },
];

// TODO: Allow to connect items with a multiple groups
export const task: Task = {
  id: "d2e1e1fd-0723-47e4-8baa-ab52d96e20f3",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "ba0f3774-4617-4de7-8529-bab966f33ce6",
      itemsId: ["bf24f8ff-f8a6-4f8f-a8ac-278af682105f"],
    },
    {
      groupId: "73eda6e7-87ed-49ca-accd-61143de3073f",
      itemsId: ["88c5e278-f955-49c0-abf4-661f56e80769"],
    },
    {
      groupId: "654c1d80-74d8-49c2-8408-46f781358e7d",
      itemsId: ["a5229193-0323-4b85-811c-ab64df0a08bb"],
    },
    {
      groupId: "b4af847b-5ce3-443d-a30d-52a73b1bf253",
      itemsId: ["949d8199-0ef2-47db-ac12-db7f86438179"],
    },
    {
      groupId: "a0a7ac46-b9bc-4f33-a684-f55fb862138c",
      itemsId: ["5272da7d-b336-4b7d-941a-298ceebc2bc1"],
    },
  ],
};
